import request from '@/utils/request'

/**
 * 账号统计分析API接口模块
 * 提供当前账号的统计分析数据和桥梁日统计数据
 */

/**
 * 获取当前账号统计分析
 * @param {string} month - 月份参数 (可选，格式：YYYY-MM)
 * @returns {Promise<{code: number, message: string, data: {
 *   bridgeCount: number,
 *   bridgeList: Array<{id: number, bridgeName: string}>,
 *   totalNavigationCount: number,
 *   monthlyNavigationCount: number,
 *   totalAlertCount: number,
 *   monthlyAlertCount: number,
 *   monthlyDeviationCount: number,
 *   monthlyOverheightCount: number,
 *   monthlyOverspeedCount: number,
 *   monthlyDetentionCount: number,
 *   monthlyBlacklistCount: number
 * }}>} 当前账号统计分析数据
 */
export function getCurrentAccountStatistics(month) {
  return request({
    url: '/account-statistics/current',
    method: 'get',
    params: month ? { month } : {}
  })
}

/**
 * 获取桥梁当日统计分析
 * @param {number} bridgeId - 桥梁ID
 * @returns {Promise<{code: number, message: string, data: {
 *   bridgeId: number,
 *   bridgeName: string,
 *   todayNavigationCount: number,
 *   todayAlertCount: number,
 *   todayDeviationCount: number,
 *   todayOverheightCount: number,
 *   todayOverspeedCount: number,
 *   todayDetentionCount: number,
 *   todayBlacklistCount: number
 * }}>} 桥梁当日统计分析数据
 */
export function getBridgeDailyStatistics(bridgeId) {
  return request({
    url: `/account-statistics/bridge/${bridgeId}/daily`,
    method: 'get'
  })
}
